<template>
  <el-dialog
    :title="`${!!promotionId ? 'Cập nhật' : 'Tạo'} khuyến mại`"
    :visible.sync="dialogformDataVisible"
    width="1200px"
    :close-on-click-modal="false"
    @open="onOpen"
    @close="onClose"
  >
    <validation-observer ref="formValidator">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-group-title">
            {{ $t('views.configuration.generalInformation') }}
          </div>
          <div class="das-form-row">
            <!-- code -->
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <validation-provider
                  rules="required|max:20|no_special"
                  :name="FIELD.code"
                >
                  <div class="label required">
                    {{ FIELD.code }}
                  </div>
                  <input
                    v-model="formData.code"
                    type="text"
                    :disabled="!!promotionId"
                  />
                </validation-provider>
              </div>
            </div>

            <!-- name -->
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <validation-provider rules="required|max:45" :name="FIELD.name">
                  <div class="label required">
                    {{ FIELD.name }}
                  </div>
                  <input v-model="formData.name" type="text" />
                </validation-provider>
              </div>
            </div>

            <!-- type -->
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <validation-provider rules="required" :name="FIELD.type">
                  <div class="label required">
                    {{ FIELD.type }}
                  </div>
                  <el-select
                    v-model="formData.type"
                    placeholder="Chọn"
                    :disabled="!!promotionId"
                    @change="onChangePromotionType"
                  >
                    <el-option
                      v-for="item in promotionTypeOptions"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>

            <!-- department_type -->
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <validation-provider
                  rules="required"
                  :name="FIELD.department_type"
                >
                  <div class="label required">
                    {{ FIELD.department_type }}
                  </div>
                  <el-select
                    v-model="formData.department_type"
                    placeholder="Chọn"
                    :disabled="!!promotionId"
                    @change="onChangeDepartment"
                  >
                    <el-option
                      v-for="item in departmentOptions"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>
          </div>

          <div class="das-form-row">
            <!-- note -->
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label">{{ FIELD.note }}</div>
                <validation-provider rules="max:200" :name="FIELD.note">
                  <textarea v-model="formData.note" rows="2" />
                </validation-provider>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formData.type != null" class="das-form-group">
          <div class="das-form-group-title">
            {{ $t('views.configuration.promotionDetail') }}
          </div>

          <!-- Common fields for both Promotion and Voucher -->
          <div class="das-form-row">
            <!-- status -->
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider rules="required" :name="FIELD.status">
                  <div class="label required">
                    {{ FIELD.status }}
                  </div>
                  <el-select v-model="formData.status" placeholder="Chọn">
                    <el-option
                      v-for="item in promotionStatusOptions"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>

            <!-- start_date -->
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider rules="required" :name="FIELD.start_date">
                  <div class="label required">
                    {{ FIELD.start_date }}
                  </div>
                  <CalendarSelect
                    v-model="formData.start_date"
                    style="display: block; width: 100%"
                    mode="date"
                    @input="onChangeDateFrom"
                  />
                </validation-provider>
              </div>
            </div>
            <!-- end_date -->
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider rules="required" :name="FIELD.end_date">
                  <div class="label required">
                    {{ FIELD.end_date }}
                  </div>
                  <CalendarSelect
                    v-model="formData.end_date"
                    style="display: block; width: 100%"
                    mode="date"
                    @input="onChangeDateTo"
                  />
                </validation-provider>
              </div>
            </div>
          </div>

          <div v-if="formData.type == CODE_VOUCHER" class="das-form-row">
            <!-- number_sub_voucher - chỉ hiển thị khi tạo mới -->
            <div
              v-if="!promotionId"
              class="das-form-col col-4"
            >
              <div class="das-form-input">
                <validation-provider
                  rules="required|number|min_value:1"
                  :name="FIELD.number_sub_voucher"
                >
                  <div class="label required">
                    {{ FIELD.number_sub_voucher }}
                  </div>
                  <input
                    v-model="formData.number_sub_voucher"
                    v-numeric-only
                    min="1"
                    type="text"
                  />
                </validation-provider>
              </div>
            </div>
            <!-- prefix - hiển thị sau Số lượng Voucher -->
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider
                  rules="required|max:10|no_special"
                  :name="FIELD.prefix"
                >
                  <div class="label required">
                    {{ FIELD.prefix }}
                  </div>
                  <input v-model="formData.prefix" type="text" />
                </validation-provider>
              </div>
            </div>
          </div>

          <!-- Additional fields for promotion-new API -->
          <div class="das-form-row">
            <!-- description -->
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <validation-provider rules="max:200" :name="FIELD.description">
                  <div class="label">{{ FIELD.description }}</div>
                  <textarea v-model="formData.description" rows="2" />
                </validation-provider>
              </div>
            </div>
          </div>

          <!-- <div v-if="formData.type == CODE_PROMOTION" class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider
                  rules="number|min_value:0"
                  :name="FIELD.usage_limit"
                >
                  <div class="label">{{ FIELD.usage_limit }}</div>
                  <input
                    v-model="formData.usage_limit"
                    v-numeric-only
                    min="0"
                    type="text"
                  />
                </validation-provider>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider
                  rules="number|min_value:0"
                  :name="FIELD.usage_limit_per_customer"
                >
                  <div class="label">{{ FIELD.usage_limit_per_customer }}</div>
                  <input
                    v-model="formData.usage_limit_per_customer"
                    v-numeric-only
                    min="0"
                    type="text"
                  />
                </validation-provider>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider :name="FIELD.ticket_point">
                  <div class="label">{{ FIELD.ticket_point }}</div>
                  <el-select
                    v-model="formData.ticket_point"
                    placeholder="Chọn"
                    clearable
                  >
                    <el-option
                      v-for="item in ticketPointList"
                      :key="item.id"
                      :value="item.id"
                      :label="item.name"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>
          </div> -->

          <!-- Source selection for promotion -->
          <div
            v-if="
              formData.type == CODE_PROMOTION &&
              ticketCondition?.code !== 'PM_TICKET_01'
            "
            class="das-form-row"
          >
            <!-- discount_type -->
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider
                  rules="required"
                  :name="FIELD.discount_type"
                >
                  <div class="label required">
                    {{ FIELD.discount_type }}
                  </div>
                  <el-select
                    v-model="formData.discount_type"
                    placeholder="Chọn"
                  >
                    <el-option
                      v-for="item in voucherTypeOptions"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>
            <!-- discount_value: ẩn khi PM_TICKET_00 (giá trị nằm trong bảng) -->
            <div
              v-if="ticketCondition?.code !== 'PM_TICKET_00'"
              class="das-form-col col-4"
            >
              <div class="das-form-input">
                <validation-provider
                  rules="required"
                  :name="FIELD.discount_value"
                >
                  <div class="label required">
                    {{ FIELD.discount_value }}
                  </div>
                  <input
                    v-model="displayValue"
                    type="text"
                    :disabled="formData.discount_type == null"
                    @input="onInputDiscountValue"
                    @blur="onBlurDiscountValue"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <!-- Voucher specific fields -->
          <div v-if="formData.type == CODE_VOUCHER" class="das-form-row">
            <!-- discount_type -->
            <div
              v-if="
                !(formData.department_type == DEPARTMENT_VALUE.TICKET &&
                  ticketCondition?.code === 'PM_TICKET_01')
              "
              class="das-form-col col-4"
            >
              <div class="das-form-input">
                <validation-provider
                  rules="required"
                  :name="FIELD.discount_type"
                >
                  <div class="label required">
                    {{ FIELD.discount_type }}
                  </div>
                  <el-select
                    v-model="formData.discount_type"
                    placeholder="Chọn"
                  >
                    <el-option
                      v-for="item in voucherTypeOptions"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>
            <!-- discount_value: ẩn khi PM_TICKET_00 (giá trị nằm trong bảng) -->
            <div
              v-if="
                !(formData.department_type == DEPARTMENT_VALUE.TICKET &&
                  ticketCondition?.code === 'PM_TICKET_00')
              "
              class="das-form-col col-4"
            >
              <div class="das-form-input">
                <validation-provider
                  rules="required"
                  :name="FIELD.discount_value"
                >
                  <div class="label required">
                    {{ FIELD.discount_value }}
                  </div>
                  <input
                    v-model="displayValue"
                    type="text"
                    :disabled="formData.discount_type == null"
                    @input="onInputDiscountValue"
                    @blur="onBlurDiscountValue"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formData.type != null" class="das-form-group">
          <div class="das-form-group-title">
            {{ $t('views.configuration.condition') }}
          </div>
          <div v-if="formData.type == CODE_PROMOTION" class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider
                  rules="required"
                  :name="FIELD.condition_id"
                >
                  <div class="label required">
                    {{ FIELD.condition_id }}
                  </div>
                  <el-select
                    v-model="formData.condition_id"
                    placeholder="Chọn"
                    no-data-text="Chọn loại khuyến mại và bộ phận trước"
                    @change="onChangeCondition"
                  >
                    <el-option
                      v-for="item in conditionOptions"
                      :key="item.id"
                      :value="item.id"
                      :label="item.desc"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>

            <!-- PMS - Promotion : in source/group source -->
            <template
              v-if="
                [PROMOTION_CONDITION_CODE.arriveMoreThenTwo].some(
                  code => code === condition?.code
                )
              "
            >
              <!-- min_visit_count -->
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <validation-provider
                    rules="required|integer|min_value:1"
                    :name="FIELD.min_visit_count"
                  >
                    <div class="label required">{{ FIELD.min_visit_count }}</div>
                    <input
                      v-model="formData.min_visit_count"
                      v-numeric-only
                      min="1"
                      type="text"
                    />
                  </validation-provider>
                </div>
              </div>

              <!-- max_visit_count -->
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <validation-provider
                    :rules="`integer|min_value:1|greater_than_min_visit:${formData.min_visit_count || 0}`"
                    :name="FIELD.max_visit_count"
                  >
                    <div class="label">{{ FIELD.max_visit_count }}</div>
                    <input
                      v-model="formData.max_visit_count"
                      v-numeric-only
                      min="1"
                      type="text"
                    />
                  </validation-provider>
                </div>
              </div>
            </template>

            <!-- PMS - Promotion : in source/group source -->
            <template
              v-if="
                [PROMOTION_CONDITION_CODE.inSpecificSource].some(
                  code => code === condition?.code
                )
              "
            >
              <!-- <div class="das-form-col col-4">
                <div class="das-form-input">
                  <validation-provider
                    rules="required"
                    :name="FIELD.source_group_id"
                  >
                    <div class="label required">
                      {{ FIELD.source_group_id }}
                    </div>
                    <el-select
                      v-model="formData.source_group_id"
                      placeholder="Chọn"
                      clearable
                    >
                      <el-option
                        v-for="item in sourceGroupOptions"
                        :key="item.id"
                        :value="item.id"
                        :label="item.desc"
                      >
                      </el-option>
                    </el-select>
                  </validation-provider>
                </div>
              </div> -->

              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <!-- source_ids -->
                  <div class="das-form-col col-4">
                    <div class="das-form-input">
                      <validation-provider
                        :name="FIELD.source_ids"
                        :rules="isSourceIdsRequired ? 'required' : ''"
                      >
                        <div class="label" :class="{ required: isSourceIdsRequired }">
                          {{ FIELD.source_ids }}
                        </div>
                        <el-select
                          v-model="formData.source_ids"
                          placeholder="Chọn nguồn"
                          clearable
                          multiple
                          collapse-tags
                        >
                          <el-option
                            v-for="item in sourceGroupOptions"
                            :key="item.id"
                            :value="item.id"
                            :label="item.desc"
                          >
                          </el-option>
                        </el-select>
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div
            v-if="
              formData.department_type == DEPARTMENT_VALUE.TICKET &&
              (formData.type == CODE_PROMOTION || formData.type == CODE_VOUCHER)
            "
            class="das-form-row"
          >
            <template>
              <div
                v-if="ticketCondition?.code !== 'PM_TICKET_01' && ticketCondition?.code !== 'PM_TICKET_00'"
                class="das-form-col col-4"
              >
                <div class="das-form-input">
                  <validation-provider>
                    <div class="label">
                      {{ 'Loại hình vé' }}
                    </div>
                    <el-select
                      v-model="formData.ticket_type_list"
                      placeholder="Chọn"
                      clearable
                      multiple
                      collapse-tags
                      @change="onChangeTicketType"
                    >
                      <el-option
                        v-for="item in ticketTypeOptions"
                        :key="item.id"
                        :value="item.id"
                        :label="item.name"
                      >
                      </el-option>
                    </el-select>
                  </validation-provider>
                </div>
              </div>

              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <validation-provider>
                    <div class="label">
                      {{ 'Điểm áp dụng' }}
                    </div>
                    <el-select
                      v-model="formData.ticket_point"
                      placeholder="Chọn"
                      clearable
                      @change="inputTicketPoint"
                    >
                      <el-option
                        v-for="item in ticketPointList"
                        :key="item.id"
                        :value="item.id"
                        :label="item.name"
                      >
                      </el-option>
                    </el-select>
                  </validation-provider>
                </div>
              </div>

              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <validation-provider>
                    <div class="label">
                      {{ 'Quầy áp dụng' }}
                    </div>
                    <el-select
                      v-model="formData.ticket_office_id_list"
                      placeholder="Chọn"
                      clearable
                      multiple
                      collapse-tags
                      @change="inputTicketOffice"
                    >
                      <el-option
                        v-for="item in ticketOfficeList"
                        :key="item.id"
                        :value="item.id"
                        :label="item.name"
                      >
                      </el-option>
                    </el-select>
                  </validation-provider>
                </div>
              </div>
            </template>
          </div>
          <div
            v-if="
              formData.type == CODE_PROMOTION &&
              formData.department_type == DEPARTMENT_VALUE.RECEPTIONIST
            "
            class="das-form-row"
          >
            <!-- room_type_list -->
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider :name="FIELD.room_type_list">
                  <div class="label">
                    {{ FIELD.room_type_list }}
                  </div>
                  <el-select
                    v-model="formData.room_type_list"
                    placeholder="Chọn"
                    no-data-text="Chọn loại phòng"
                    multiple
                    collapse-tags
                    @change="onChangeRoomType"

                  >
                    <el-option
                      v-for="item in roomTypeOptions"
                      :key="item.id"
                      :value="item.id"
                      :label="item.name"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>

            <!-- num_night_apply -->
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider
                  rules="min_value:1|number"
                  :name="FIELD.num_night_apply"
                >
                  <div class="label">
                    {{ FIELD.num_night_apply }}
                  </div>
                  <input
                    v-model="formData.num_night_apply"
                    v-numeric-only
                    min="1"
                    type="text"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div v-if="formData.type == CODE_VOUCHER" class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider>
                  <div class="label">
                    {{ 'Giá tối thiểu để áp dụng' }}
                  </div>
                  <input
                    v-model="displayValue2"
                    :disabled="formData.discount_type == null"
                    type="text"
                    @input="onInputMinOrderValue"
                    @blur="onBlurMinOrderValue"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider>
                  <div class="label">
                    {{ 'Giảm giá tối đa' }}
                  </div>
                  <input
                    v-model="displayValue3"
                    :disabled="formData.discount_type == null"
                    type="text"
                    @input="onInputMaxDiscountValue"
                    @blur="onBlurMaxDiscountValue"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-4" style="align-content: end">
              <validation-provider class="flex">
                <input
                  v-model="formData.stackable"
                  :disabled="formData.discount_type == null"
                  type="checkbox"
                />
                <div class="label" style="padding-left: 1rem">
                  {{ 'Có cho phép dùng cùng các voucher khác?' }}
                </div>
              </validation-provider>
            </div>
          </div>
          <div v-if="formData.type == CODE_VOUCHER && formData.department_type == DEPARTMENT_VALUE.RECEPTIONIST" class="das-form-row">
            <!-- room_type_list -->
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider :name="FIELD.room_type_list">
                  <div class="label">
                    {{ FIELD.room_type_list }}
                  </div>
                  <el-select
                    v-model="formData.room_type_list"
                    placeholder="Chọn"
                    no-data-text="Chọn loại phòng"
                    multiple
                    collapse-tags
                    @change="onChangeRoomType"
                  >
                    <el-option
                      v-for="item in roomTypeOptions"
                      :key="item.id"
                      :value="item.id"
                      :label="item.name"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>
          <!-- num_night_apply -->
          <div class="das-form-col col-4">
            <div class="das-form-input">
              <validation-provider
                rules="min_value:1|number"
                :name="FIELD.num_night_apply"
              >
                <div class="label">
                  {{ FIELD.num_night_apply }}
                </div>
                <input
                  v-model="formData.num_night_apply"
                  v-numeric-only
                  min="1"
                  type="text"
                />
              </validation-provider>
            </div>
          </div>
          </div>

          <!-- Phòng đính kèm (chỉ dùng cho website) - chỉ hiển thị khi chọn bộ phận là vé -->
          <div
            v-if="formData.department_type == DEPARTMENT_VALUE.TICKET"
            class="das-form-row"
          >
            <!-- attached_room_list -->
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider :name="FIELD.attached_room_list">
                  <div class="label">
                    {{ FIELD.attached_room_list }}
                  </div>
                  <el-select
                    v-model="formData.attached_room_list"
                    placeholder="Chọn"
                    no-data-text="Chọn loại phòng"
                    multiple
                    collapse-tags
                    @change="onChangeAttachedRoom"
                  >
                    <el-option
                      v-for="item in roomTypeOptions"
                      :key="item.id"
                      :value="item.id"
                      :label="item.name"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>
          </div>

          <!-- Điều kiện áp dụng cho vé - chỉ hiển thị khi Promotion/Voucher và Bộ phận là Vé -->
          <div
            v-if="
              (formData.type == CODE_PROMOTION || formData.type == CODE_VOUCHER) &&
              formData.department_type == DEPARTMENT_VALUE.TICKET
            "
            key="ticket-condition"
            class="das-form-row"
          >
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <validation-provider
                  :name="FIELD.ticket_condition_id"
                >
                  <div class="label">
                    {{ FIELD.ticket_condition_id }}
                  </div>
                  <el-select
                    v-model="formData.ticket_condition_id"
                    placeholder="Chọn"
                    no-data-text="Đang tải..."
                    @change="onChangeTicketCondition"
                  >
                    <el-option
                      v-for="item in ticketConditionOptions"
                      :key="item.id"
                      :value="item.id"
                      :label="item.desc"
                    >
                    </el-option>
                  </el-select>
                </validation-provider>
              </div>
            </div>
          </div>

          <!-- Bảng promotion ticket list khi chọn PM_TICKET_01 -->
          <div
            v-if="ticketCondition?.code === 'PM_TICKET_01'"
            class="das-form-row"
          >
            <div class="das-form-col col-12">
              <promotion-ticket-list-table
                :ticket-list="formData.promotion_ticket_list"
                :ticket-type-options="ticketTypeOptions"
                @update-field="handleUpdateTicketField"
                @add-row="addPromotionTicketRow"
                @remove-row="removePromotionTicketRow"
              />
            </div>
          </div>

          <!-- Bảng vé áp dụng khi chọn PM_TICKET_00 (Cấu hình chung) -->
          <div
            v-if="
              (formData.type == CODE_PROMOTION || formData.type == CODE_VOUCHER) &&
              formData.department_type == DEPARTMENT_VALUE.TICKET &&
              ticketCondition?.code === 'PM_TICKET_00'
            "
            class="das-form-row"
          >
            <div class="das-form-col col-12">
              <promotion-apply-ticket-list-table
                :ticket-list="formData.promotion_apply_ticket_list"
                :ticket-type-options="ticketTypeOptions"
                :discount-type="formData.discount_type"
                @update-field="handleUpdateApplyTicketField"
                @add-row="addPromotionApplyTicketRow"
                @remove-row="removePromotionApplyTicketRow"
              />
            </div>
          </div>
        </div>

        <!-- KHUYẾN MẠI ÁP DỤNG (đã bỏ, để trong backup.txt) -->
      </div>
    </validation-observer>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogformDataVisible = false"
        >
          {{ $t('button.cancel') }}
        </button>
        <button
          v-if="!!promotionId"
          class="btn primary small"
          @click="fnUpdatePromotion"
        >
          {{ $t('button.update') }}
        </button>
        <button v-else class="btn primary small" @click="fnCreatePromotion">
          {{ $t('button.create') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import PromotionTicketListTable from './PromotionTicketListTable.vue'
import PromotionApplyTicketListTable from './PromotionApplyTicketListTable.vue'
import {
  DEPARTMENT_VALUE,
  PROMOTION_STATUS_VALUE,
  PROMOTION_TYPE_VALUE,
  PROMOTION_CONDITION_CODE,
  PROMOTION_APPLY_CODE,
  VOUCHER_TYPE_VALUE
} from './constant'

import { downloadFile } from '@/utils/file-handler'

import { fnGetCodeBaseList } from './utils'
import { getSourceGroupApi } from '@/api/Statistics/sourceGroup'
import { getSourceListApi } from '@/api/common/source'
import {
  // eslint-disable-next-line no-unused-vars
  getTicketTypeApi,
  getNoChildTicketApi,
  createNewPromotion,
  updateNewPromotion,
  getNewPromotionDetail,
  createVoucher,
  updateVoucher,
  getVoucherDetail,
  getTicketPointListApi,
  getTicketOfficeListApi,
  getTicketListApi
} from '@/api/booking_service/promotion'
import { getAllRoomLevelApi } from '@/api/Room/roomLevel'
import { notifyError, notifySuccess } from '@/utils/toast'

export default {
  components: { CalendarSelect, PromotionTicketListTable, PromotionApplyTicketListTable },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    promotionId: {
      type: [Number, null]
    },
    type: {
      type: Number
    },
    searchParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      DEPARTMENT_VALUE,
      PROMOTION_CONDITION_CODE,
      PROMOTION_APPLY_CODE,
      formData: {
        code: null,
        type: null,
        name: null,
        note: null,
        status: 0,
        id: this.promotionId || null,
        department_type: null,
        start_date: null,
        end_date: null,
        condition_id: null,
        ticket_condition_id: null,
        apply_id: null,
        source_id: null,
        // source_group_id: null,
        total_room_charge_discount_percent: null,
        voucher_pms_ticket: false,
        voucher_website: false,
        voucher_pms_ticket_quantity: null,
        voucher_website_quantity: null,
        discount_total_bill_percent: null,
        free_ticket_quantity: null,
        source_ticket_id: null,
        des_ticket_id: null,
        discount_des_ticket: null,
        buy_ticket_quantity: null,
        no_child_ticket_id: null,
        discount_no_child_ticket: null,
        ticket_type_id: null,
        num_of_ticket: null,
        number_sub_voucher: null,
        ticket_office_id_list: null,
        ticket_point_id: null,
        discount_type: null,
        discount_value: 0,
        min_order_value: null,
        max_discount_value: null,
        stackable: false,
        ticket_type_list: [],
        room_type_list: [],
        attached_room_list: [],
        promotion_ticket_list: [],
        promotion_apply_ticket_list: [],
        num_night_apply: null,
        prefix: null,
        description: null,
        min_visit_count: null,
        max_visit_count: null,
        usage_limit: null,
        usage_limit_per_customer: null,
        ticket_point: null,
        source_ids: null
      },
      defaultFormData: {
        code: null,
        type: null,
        name: null,
        note: null,
        status: 0,
        id: this.promotionId || null,
        department_type: null,
        start_date: null,
        end_date: null,
        condition_id: null,
        ticket_condition_id: null,
        apply_id: null,
        source_id: null,
        // source_group_id: null,
        total_room_charge_discount_percent: null,
        voucher_pms_ticket: false,
        voucher_website: false,
        voucher_pms_ticket_quantity: null,
        voucher_website_quantity: null,
        discount_total_bill_percent: null,
        free_ticket_quantity: null,
        source_ticket_id: null,
        des_ticket_id: null,
        discount_des_ticket: null,
        buy_ticket_quantity: null,
        no_child_ticket_id: null,
        discount_no_child_ticket: null,
        ticket_type_id: null,
        num_of_ticket: null,
        number_sub_voucher: null,
        discount_type: null,
        discount_value: 0,
        min_order_value: null,
        max_discount_value: null,
        stackable: false,
        ticket_type_list: [],
        room_type_list: [],
        attached_room_list: [],
        promotion_ticket_list: [],
        promotion_apply_ticket_list: [],
        num_night_apply: null,
        prefix: null,
        description: null,
        min_visit_count: null,
        max_visit_count: null,
        usage_limit: null,
        usage_limit_per_customer: null,
        ticket_point: null,
        source_ids: null
      },
      defaultValueIfChange: {
        source_id: null,
        // source_group_id: null,
        total_room_charge_discount_percent: null,
        voucher_pms_ticket: false,
        voucher_website: false,
        voucher_pms_ticket_quantity: null,
        voucher_website_quantity: null,
        discount_total_bill_percent: null,
        free_ticket_quantity: null,
        source_ticket_id: null,
        des_ticket_id: null,
        discount_des_ticket: null,
        buy_ticket_quantity: null,
        no_child_ticket_id: null,
        discount_no_child_ticket: null,
        ticket_type_id: null,
        num_of_ticket: null,
        number_sub_voucher: null,
        discount_type: null,
        discount_value: 0,
        min_order_value: null,
        max_discount_value: null,
        stackable: false,
        // ticket_type_list: [], // Removed - không reset khi chuyển loại khuyến mại
        room_type_list: [],
        promotion_ticket_list: [],
        promotion_apply_ticket_list: [],
        num_night_apply: null,
        prefix: null,
        description: null,
        min_visit_count: null,
        max_visit_count: null,
        usage_limit: null,
        usage_limit_per_customer: null,
        ticket_point: null,
        source_ids: null,
        attached_room_list: [],
        ticket_condition_id: null
      },
      FIELD: {
        code: 'Mã khuyến mại',
        type: 'Loại khuyến mại',
        name: 'Tên khuyến mại',
        note: 'Ghi chú',
        status: 'Trạng thái',
        department_type: 'Bộ phận',
        start_date: 'Ngày bắt đầu',
        end_date: 'Ngày kết thúc',
        condition_id: 'Điều kiện áp dụng',
        ticket_condition_id: 'Điều kiện áp dụng cho vé',
        apply_id: 'Nội dung',
        source_id: 'Nguồn',
        source_group_id: 'Nhóm nguồn',
        total_room_charge_discount_percent: 'Giảm giá (%)',
        voucher_pms_ticket: 'Sử dụng voucher đặt qua PMS-Ticket',
        voucher_website: 'Sử dụng voucher đặt qua website',
        voucher_pms_ticket_quantity: 'Số lượng voucher đặt qua PMS-Ticket',
        voucher_website_quantity: 'Số lượng voucher đặt qua website',
        discount_total_bill_percent: 'Giảm giá tổng bill (%)',
        free_ticket_quantity: 'Số lượng vé miễn phí',
        source_ticket_id: 'Mua loại vé',
        des_ticket_id: 'Loại vé khác',
        discount_des_ticket: 'Giảm giá vé khác (%)',
        buy_ticket_quantity: 'Số lượng vé mua',
        no_child_ticket_id: 'Vé không phân biệt người lớn/trẻ em',
        discount_no_child_ticket: 'Giảm giá vé trẻ em (%)',
        ticket_type_id: '', // no use
        num_of_ticket: 'Số lượng vé mua',
        number_sub_voucher: 'Số lượng Voucher',
        discount_type: 'Loại giảm giá',
        discount_value: 'Giá trị giảm',
        ticket_type_list: 'Loại vé áp dụng',
        room_type_list: 'Loại phòng áp dụng',
        attached_room_list: 'Phòng đính kèm(chỉ dùng cho website)',
        num_night_apply: 'Số đêm áp dụng',
        prefix: 'Prefix',
        description: 'Mô tả',
        min_visit_count: 'Số lần tối thiểu khách đã đến',
        max_visit_count: 'Số lần tối đa khách đã đến',
        usage_limit: 'Số lượng voucher tổng',
        usage_limit_per_customer: 'Số lượng voucher mỗi khách hàng',
        ticket_point: 'Điểm áp dụng',
        source_ids: 'Nguồn áp dụng'
      },

      condition: null, // selected
      ticketCondition: null, // selected ticket condition
      apply: null, // selected

      departmentOptions: [
        {
          value: DEPARTMENT_VALUE.RECEPTIONIST,
          label: this.$t('variables.receptionist')
        },
        {
          value: DEPARTMENT_VALUE.TICKET,
          label: this.$t('variables.ticket')
        }
      ],
      promotionTypeOptions: [
        {
          value: PROMOTION_TYPE_VALUE.PROMOTION,
          label: 'Promotion'
        },
        {
          value: PROMOTION_TYPE_VALUE.VOUCHER,
          label: 'Voucher'
        }
      ],
      promotionStatusOptions: [
        {
          value: PROMOTION_STATUS_VALUE.APPLYING,
          label: this.$t('variables.applying')
        },
        {
          value: PROMOTION_STATUS_VALUE.STOP_APPLYING,
          label: this.$t('variables.stopApplying')
        }
      ],
      voucherTypeOptions: [
        {
          value: VOUCHER_TYPE_VALUE.PERCENT,
          label: 'Giảm theo phần trăm'
        },
        {
          value: VOUCHER_TYPE_VALUE.FIXED,
          label: 'Giảm theo giá'
        }
      ],
      ticketOptions: [],
      noChildTicketOptions: [],
      ticketTypeOptions: [],
      roomTypeOptions: [],
      sourceOptions: [],
      sourceGroupOptions: [],
      ticketPointList: [],
      ticketOfficeList: [],
      conditionOptions: [],
      ticketConditionOptions: [],
      applyOptions: [],
      CODE_PROMOTION: null,
      CODE_VOUCHER: null,
      VOUCHER_FIXED: null,
      VOUCHER_PERCENT: null,
      displayValue: 0,
      displayValue2: 0,
      displayValue3: 0
    }
  },

  computed: {
    dialogformDataVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    isSourceIdsRequired() {
      return this.condition?.code === PROMOTION_CONDITION_CODE.inSpecificSource
    }
  },

  watch: {
    // Cái này CHATGPT viết, không rõ tại sao lại thế
    // Sync displayValue when formData.discount_value changes
    'formData.discount_value'(newVal) {
      this.updateDisplayDiscountValue(newVal)
    },
    // Sync displayValue when formData.discount_type changes
    'formData.discount_type'() {
      this.updateDisplayDiscountValue(this.formData.discount_value)
    },

    'formData.min_order_value'(newVal) {
      this.updateDisplayMinOrderValue(newVal)
    },
    'formData.max_discount_value'(newVal) {
      this.updateDisplayMaxDiscountValue(newVal)
    }
  },
  created() {
    this.CODE_PROMOTION = PROMOTION_TYPE_VALUE.PROMOTION
    this.CODE_VOUCHER = PROMOTION_TYPE_VALUE.VOUCHER

    this.VOUCHER_FIXED = VOUCHER_TYPE_VALUE.FIXED
    this.VOUCHER_PERCENT = VOUCHER_TYPE_VALUE.PERCENT
  },

  beforeMount() {
    Promise.all([
      this.getSourceList(),
      this.getTicketPointList(),
      this.getTicketOfficeList(),
      this.getSourceGroupList(),
      this.getTicketOptions(),
      this.getNoChildTicketOptions(),
      this.geTicketType(),
      this.getRoomType()
    ])
  },

  methods: {
    // utils:
    updateDisplayDiscountValue(value) {
      if (this.formData.discount_type === VOUCHER_TYPE_VALUE.FIXED) {
        this.displayValue = new Intl.NumberFormat('vi-VN', {
          style: 'currency',
          currency: 'VND'
        }).format(value)
      } else if (this.formData.discount_type === VOUCHER_TYPE_VALUE.PERCENT) {
        this.displayValue = `${value}%`
      } else {
        this.displayValue = value.toString()
      }
    },
    updateDisplayMinOrderValue(value) {
      this.displayValue2 = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND'
      }).format(value)
    },
    updateDisplayMaxDiscountValue(value) {
      this.displayValue3 = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND'
      }).format(value)
    },
    onInputDiscountValue(event) {
      const inputValue = event.target.value

      if (this.formData.discount_type === VOUCHER_TYPE_VALUE.FIXED) {
        const numericValue = parseFloat(inputValue.replace(/[^0-9]/g, ''))
        this.formData.discount_value = Math.max(
          0,
          isNaN(numericValue) ? 0 : numericValue
        )
      } else if (this.formData.discount_type === VOUCHER_TYPE_VALUE.PERCENT) {
        const numericValue = parseFloat(inputValue.replace(/[^0-9]/g, ''))
        this.formData.discount_value = Math.max(
          0,
          Math.min(100, isNaN(numericValue) ? 0 : numericValue)
        )
      }
    },
    onBlurDiscountValue() {
      this.updateDisplayDiscountValue(this.formData.discount_value) // Reformat display value on blur
    },
    onInputMinOrderValue(event) {
      const inputValue = event.target.value

      const numericValue = parseFloat(inputValue.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue) || numericValue === 0) {
        this.formData.min_order_value = null
      } else {
        this.formData.min_order_value = Math.max(0, numericValue)
      }
    },
    onBlurMinOrderValue() {
      this.updateDisplayMinOrderValue(this.formData.min_order_value) // Reformat display value on blur
    },
    onInputMaxDiscountValue(event) {
      const inputValue = event.target.value

      const numericValue = parseFloat(inputValue.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue) || numericValue === 0) {
        this.formData.max_discount_value = null
      } else {
        this.formData.max_discount_value = Math.max(0, numericValue)
      }
    },
    onBlurMaxDiscountValue() {
      this.updateDisplayMaxDiscountValue(this.formData.max_discount_value) // Reformat display value on blur
    },
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.saleStartDateMustBeforeEnd')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.formData.start_date = date
      if (!this.checkValidDateRange(date, this.formData.end_date)) {
        setTimeout(() => {
          this.formData.end_date = null
        })
      }
    },

    onChangeDateTo(date) {
      this.formData.end_date = date
      if (!this.checkValidDateRange(this.formData.start_date, date)) {
        setTimeout(() => {
          this.formData.end_date = null
        })
      }
    },
    async getCondition(promotionType, departmentType) {
      let pCode
      if (
        promotionType === PROMOTION_TYPE_VALUE.PROMOTION &&
        departmentType === DEPARTMENT_VALUE.RECEPTIONIST
      ) {
        pCode = 'PM_PMS'
      } else if (
        promotionType === PROMOTION_TYPE_VALUE.PROMOTION &&
        departmentType === DEPARTMENT_VALUE.TICKET
      ) {
        // pCode = 'PM_TICKET'
        pCode = 'PM_PMS'
      } else if (
        promotionType === PROMOTION_TYPE_VALUE.VOUCHER &&
        departmentType === DEPARTMENT_VALUE.RECEPTIONIST
      ) {
        pCode = 'VC_PMS'
      } else if (
        promotionType === PROMOTION_TYPE_VALUE.VOUCHER &&
        departmentType === DEPARTMENT_VALUE.TICKET
      ) {
        pCode = 'VC_TICKET'
      }
      this.conditionOptions = await fnGetCodeBaseList(pCode)

      // Nếu đang tạo mới (không có promotionId) và có conditionOptions, chọn giá trị đầu tiên
      if (!this.promotionId && this.conditionOptions && this.conditionOptions.length > 0) {
        const firstCondition = this.conditionOptions[0]
        this.formData.condition_id = firstCondition.id
        this.condition = firstCondition

        // Tự động gọi getApply với condition đầu tiên
        await this.getApply(firstCondition.code)
      }

      // Gọi getTicketCondition nếu là Promotion/Voucher và bộ phận là Vé
      if (
        (promotionType === PROMOTION_TYPE_VALUE.PROMOTION || promotionType === PROMOTION_TYPE_VALUE.VOUCHER) &&
        departmentType === DEPARTMENT_VALUE.TICKET
      ) {
        await this.getTicketCondition()
      } else {
        this.ticketConditionOptions = []
        this.formData.ticket_condition_id = null
        this.ticketCondition = null
        // Chỉ reset promotion_ticket_list nếu không đang edit hoặc không có dữ liệu
        if (!this.promotionId || !this.formData.promotion_ticket_list || this.formData.promotion_ticket_list.length === 0) {
          this.formData.promotion_ticket_list = [{
            ticket: null,
            discount: null,
            ticket_type: null,
            ticket_num: 0,
            ticket_discount: null,
            ticket_discount_type: null,
            ticket_discount_num: 0
          }]
        }
      }

      // this.conditionOptions = [
      //   {
      //     id: 1,
      //     code: 'PM_PMS_01',
      //     desc: 'Theo số lần khách đã đến'
      //   },
      //   {
      //     id: 2,
      //     desc: 'Khách thuộc nhóm/nguồn'
      //   }
      // ]
    },
    async getTicketCondition() {
      this.ticketConditionOptions = await fnGetCodeBaseList('PM_TICKET')

      // Nếu đang tạo mới (không có promotionId) và có ticketConditionOptions, chọn giá trị đầu tiên
      if (!this.promotionId && this.ticketConditionOptions && this.ticketConditionOptions.length > 0) {
        const firstTicketCondition = this.ticketConditionOptions[0]
        this.formData.ticket_condition_id = firstTicketCondition.id
        this.ticketCondition = firstTicketCondition
        // Nếu là PM_TICKET_01 hoặc PM_TICKET_00, set giá trị mặc định cho discount_type và discount_value
        if (firstTicketCondition.code === 'PM_TICKET_01') {
          this.formData.discount_type = VOUCHER_TYPE_VALUE.PERCENT
          this.formData.discount_value = 0
          this.updateDisplayDiscountValue(0)
          // Reset bảng về giá trị ban đầu
          this.resetPromotionTicketList()
        } else if (firstTicketCondition.code === 'PM_TICKET_00') {
          this.formData.discount_type = VOUCHER_TYPE_VALUE.PERCENT
          this.formData.discount_value = 0
          this.updateDisplayDiscountValue(0)
          this.resetPromotionApplyTicketList()
        }
      }
    },
    inputTicketPoint(value) {
      this.formData.ticket_office_id_list = null
      this.formData.ticket_point_id = value
      this.formData.ticket_point = value
    },
    onChangeTicketType() {
    },
    inputTicketOffice() {
      this.formData.ticket_point_id = null
      this.formData.ticket_point = null
    },
    async getApply(conditionCode) {
      let res
      switch (conditionCode) {
        case PROMOTION_CONDITION_CODE.arriveMoreThenTwo:
          res = await fnGetCodeBaseList('PM_APPLY_PMS')
          this.applyOptions = res.filter(item =>
            [
              PROMOTION_APPLY_CODE.roomCharge,
              PROMOTION_APPLY_CODE.cauKinh
            ].some(code => item.code === code)
          )
          break
        case PROMOTION_CONDITION_CODE.inSpecificSource:
          res = await fnGetCodeBaseList('PM_APPLY_PMS')
          this.applyOptions = res.filter(item =>
            [
              PROMOTION_APPLY_CODE.roomCharge,
              PROMOTION_APPLY_CODE.cauKinhAndFood
            ].some(code => item.code === code)
          )
          break
        case PROMOTION_CONDITION_CODE.haveRoomHaveTicket:
          res = await fnGetCodeBaseList('PM_APPLY_PMS')
          this.applyOptions = res.filter(item =>
            [PROMOTION_APPLY_CODE.roomCharge, PROMOTION_APPLY_CODE.food].some(
              code => item.code === code
            )
          )
          break

        case PROMOTION_CONDITION_CODE.bookingUseVoucher:
          res = await fnGetCodeBaseList('VC_APPLY_PMS')
          this.applyOptions = res
          this.apply = this.applyOptions.find(
            item => item?.code === PROMOTION_APPLY_CODE.bookingUseVoucher
          )
          this.formData.apply_id = this.apply.id
          break

        case PROMOTION_CONDITION_CODE.ticketType:
          res = await fnGetCodeBaseList('PM_APPLY_TICKET')
          this.applyOptions = res
          this.apply = this.applyOptions.find(
            item =>
              item?.code === PROMOTION_APPLY_CODE.decreaseTicketTypePercentage
          )
          this.formData.apply_id = this.apply.id
          break
        case PROMOTION_CONDITION_CODE.ticketQuantity:
          res = await fnGetCodeBaseList('PM_APPLY_TICKET')
          this.applyOptions = res
          this.apply = this.applyOptions.find(
            item => item?.code === PROMOTION_APPLY_CODE.freeSomeTicket
          )
          this.formData.apply_id = this.apply.id
          break
        case PROMOTION_CONDITION_CODE.ticketKid:
          res = await fnGetCodeBaseList('PM_APPLY_TICKET')
          this.applyOptions = res
          this.apply = this.applyOptions.find(
            item => item?.code === PROMOTION_APPLY_CODE.decreaseTicketPrice
          )
          this.formData.apply_id = this.apply.id
          break

        case PROMOTION_CONDITION_CODE.ticketValid:
          res = await fnGetCodeBaseList('VC_APPLY_TICKET')
          this.applyOptions = res
          this.apply = this.applyOptions.find(
            item => item?.code === PROMOTION_APPLY_CODE.decreaseBill
          )
          this.formData.apply_id = this.apply.id
          break
        case PROMOTION_CONDITION_CODE.ticketCauKinh:
          res = await fnGetCodeBaseList('VC_APPLY_TICKET')
          this.applyOptions = res
          this.apply = this.applyOptions.find(
            item => item?.code === PROMOTION_APPLY_CODE.voucherFreeSomeTicket
          )
          this.formData.apply_id = this.apply.id
          break
        case PROMOTION_CONDITION_CODE.ticketAirSlide:
          res = await fnGetCodeBaseList('VC_APPLY_TICKET')
          this.applyOptions = res
          this.apply = this.applyOptions.find(
            item => item?.code === PROMOTION_APPLY_CODE.voucherFreeSomeTicket
          )
          this.formData.apply_id = this.apply.id
          break
        case PROMOTION_CONDITION_CODE.ticketPlay:
          res = await fnGetCodeBaseList('VC_APPLY_TICKET')
          this.applyOptions = res
          this.apply = this.applyOptions.find(
            item => item?.code === PROMOTION_APPLY_CODE.voucherFreeSomeTicket
          )
          this.formData.apply_id = this.apply.id
          break

        default:
          this.applyOptions = []
          break
      }
    },
    // handle event
    onOpen() {
      console.log('promotionId onOpen:', this.promotionId)
      console.log('this.searchParams onOpen:', this.searchParams)
      if (this.promotionId) {
        this.formData.id = this.promotionId
        this.formData.type =
          this.searchParams?.applyType != null
            ? this.searchParams?.applyType
            : 0
        console.log('this.type onOpen:', this.formData.type)
        // get detail if
        this.fnGetPromotionDetail()
      } else {
        // Reset form khi tạo mới
        this.formData = Object.assign({}, this.defaultFormData)
        // Reset promotion_ticket_list về 1 hàng mặc định
        this.formData.promotion_ticket_list = [{
          ticket: null,
          discount: null,
          ticket_type: null,
          ticket_num: 0,
          ticket_discount: null,
          ticket_discount_type: null,
          ticket_discount_num: 0
        }]
        this.formData.promotion_apply_ticket_list = [{
          ticket: null,
          customer_type: null,
          discount_value: null
        }]
        this.conditionOptions = []
        this.ticketConditionOptions = []
        this.applyOptions = []
        this.condition = null
        this.ticketCondition = null
        this.apply = null
        this.displayValue = 0
        this.displayValue2 = 0
        this.displayValue3 = 0
      }
    },
    onClose() {
      // Reset form data về default
      this.formData = Object.assign({}, this.defaultFormData)
      // Reset promotion_ticket_list về 1 hàng mặc định (luôn luôn reset về 1 hàng)
      this.formData.promotion_ticket_list = [{
        ticket: null,
        discount: null,
        ticket_type: null,
        ticket_num: 0,
        ticket_discount: null,
        ticket_discount_type: null,
        ticket_discount_num: 0
      }]
      this.formData.promotion_apply_ticket_list = [{
        ticket: null,
        customer_type: null,
        discount_value: null
      }]
      // Reset các options và conditions
      this.conditionOptions = []
      this.ticketConditionOptions = []
      this.applyOptions = []
      this.condition = null
      this.ticketCondition = null
      this.apply = null
      // Reset display values
      this.displayValue = 0
      this.displayValue2 = 0
      this.displayValue3 = 0
    },

    onChangeCondition(selected) {
      this.condition = this.conditionOptions.find(item => item.id === selected)
      if (this.condition != null) {
        this.getApply(this.condition?.code)
      }

      // reset dependency
      this.formData.apply_id = null
      this.apply = null

      // this.formData = { ...this.formData, ...this.defaultValueIfChange }
    },
    onChangeTicketCondition(selected) {
      console.log('DEBUG: onChangeTicketCondition', selected)
      this.ticketCondition = this.ticketConditionOptions.find(item => item.id === selected)

      // Reset các trường liên quan khi thay đổi condition
      if (this.ticketCondition?.code === 'PM_TICKET_01') {
        this.formData.discount_type = VOUCHER_TYPE_VALUE.PERCENT
        this.formData.discount_value = 0
        this.updateDisplayDiscountValue(0)
        this.resetPromotionTicketList()
        this.formData.promotion_apply_ticket_list = []
        this.formData.ticket_type_list = []
      } else if (this.ticketCondition?.code === 'PM_TICKET_00') {
        this.formData.discount_type = VOUCHER_TYPE_VALUE.PERCENT
        this.formData.discount_value = 0
        this.updateDisplayDiscountValue(0)
        this.resetPromotionApplyTicketList()
        this.formData.promotion_ticket_list = []
        this.formData.ticket_type_list = []
      } else {
        this.formData.promotion_ticket_list = []
        this.formData.promotion_apply_ticket_list = []
      }
    },
    resetPromotionTicketList() {
      console.log('DEBUG: re init')
      this.formData.promotion_ticket_list = [{
        ticket: null,
        discount: null,
        ticket_type: null,
        ticket_num: 0,
        ticket_discount: null,
        ticket_discount_type: null,
        ticket_discount_num: 0
      }]
    },
    resetPromotionApplyTicketList() {
      this.formData.promotion_apply_ticket_list = [{
        ticket: null,
        customer_type: null,
        discount_value: null
      }]
    },
    hasDuplicateApplyTickets(list) {
      const seen = new Set()
      return list.some(item => {
        const key = `${item.ticket ?? '__null__'}_${item.customer_type ?? '__null__'}`
        if (seen.has(key)) return true
        seen.add(key)
        return false
      })
    },
    hasDuplicatePromotionTickets(list) {
      const seen = new Set()
      return list.some(item => {
        const key = `${item.ticket ?? '__null__'}_${item.ticket_type ?? '__null__'}`
        if (seen.has(key)) return true
        seen.add(key)
        return false
      })
    },
    addPromotionTicketRow(payload) {
      console.log('DEBUG: addPromotionTicketRow - Adding new row')
      console.log('DEBUG: payload:', payload)
      console.log('DEBUG: Current formData.promotion_ticket_list length:', this.formData.promotion_ticket_list.length)

      // Xử lý cả hai trường hợp: object hoặc không có payload
      let updatedList = null

      if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        // Nhận object từ component con
        updatedList = payload.updatedList
      }

      if (updatedList) {
        // Cập nhật từ component con
        console.log('DEBUG: Updating from component - updatedList:', updatedList)
        this.formData.promotion_ticket_list = updatedList
      } else {
        // Fallback: Thêm hàng mới vào đầu tiên (unshift thay vì push)
        console.log('DEBUG: Adding row directly to formData')
        this.formData.promotion_ticket_list.unshift({
          ticket: null,
          discount: null,
          ticket_type: null,
          ticket_num: 0,
          ticket_discount: null,
          ticket_discount_type: null,
          ticket_discount_num: 0
        })
      }

      console.log('DEBUG: After adding row, formData.promotion_ticket_list length:', this.formData.promotion_ticket_list.length)
      console.log('DEBUG: Updated formData.promotion_ticket_list:', JSON.parse(JSON.stringify(this.formData.promotion_ticket_list)))

      // Scroll lên đầu để thấy dòng mới
      this.$nextTick(() => {
        const tableContainer = this.$el.querySelector('.promotion-ticket-table')
        if (tableContainer) {
          tableContainer.scrollTop = 0
        }
      })
    },
    removePromotionTicketRow(payload) {
      console.log('DEBUG: removePromotionTicketRow - Removing row')
      console.log('DEBUG: payload:', payload)
      console.log('DEBUG: Current formData.promotion_ticket_list length:', this.formData.promotion_ticket_list.length)

      // Xử lý cả hai trường hợp: object hoặc index trực tiếp
      let index = null
      let updatedList = null

      if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        // Nhận object từ component con
        index = payload.index
        updatedList = payload.updatedList
      } else if (typeof payload === 'number') {
        // Nhận index trực tiếp (fallback)
        index = payload
      }

      if (updatedList) {
        // Cập nhật từ component con
        console.log('DEBUG: Updating from component - updatedList:', updatedList)
        this.formData.promotion_ticket_list = updatedList
      } else if (typeof index === 'number') {
        // Fallback: Xóa trực tiếp
        console.log('DEBUG: Removing row directly from formData at index:', index)
        if (this.formData.promotion_ticket_list.length > 1) {
          this.formData.promotion_ticket_list.splice(index, 1)
        } else {
          console.log('DEBUG: Cannot remove row - only one row remaining')
        }
      }

      console.log('DEBUG: After removing row, formData.promotion_ticket_list length:', this.formData.promotion_ticket_list.length)
      console.log('DEBUG: Updated formData.promotion_ticket_list:', JSON.parse(JSON.stringify(this.formData.promotion_ticket_list)))
    },
    handleUpdateTicketField({ index, field, value, updatedList }) {
      // DEBUG: Log khi một giá trị được chọn trong el-select
      console.log(`DEBUG: handleUpdateTicketField - index: ${index}, field: ${field}, value:`, value)
      console.log(`DEBUG: Updated list from component:`, updatedList)

      // Cập nhật formData.promotion_ticket_list với danh sách đã được cập nhật từ component
      this.formData.promotion_ticket_list = updatedList

      // DEBUG: Log sau khi cập nhật
      this.$nextTick(() => {
        const afterUpdate = JSON.parse(JSON.stringify(this.formData.promotion_ticket_list[index]))
        console.log(`DEBUG: formData.promotion_ticket_list[${index}] after update:`, afterUpdate)
        console.log(`DEBUG: item.${field} after update:`, afterUpdate[field])
        console.log(`DEBUG: Full formData.promotion_ticket_list:`, JSON.parse(JSON.stringify(this.formData.promotion_ticket_list)))
      })
    },
    formatPromotionTicketList(list) {
      if (!list || !Array.isArray(list)) {
        return []
      }
      return list.map(item => ({
        ...item,
        ticket_num: item.ticket_num != null ? Number(item.ticket_num) : 0,
        ticket_discount_num: item.ticket_discount_num != null ? Number(item.ticket_discount_num) : 0
      }))
    },
    formatPromotionApplyTicketList(list) {
      if (!list || !Array.isArray(list)) {
        return []
      }
      const discountType = this.formData.discount_type != null
        ? Number(this.formData.discount_type)
        : VOUCHER_TYPE_VALUE.PERCENT
      return list.map(item => ({
        ticket: item.ticket != null ? item.ticket : null,
        customer_type: item.customer_type != null ? item.customer_type : null,
        discount_type: discountType,
        discount_value: item.discount_value != null && item.discount_value !== ''
          ? Number(item.discount_value)
          : null
      }))
    },
    addPromotionApplyTicketRow(payload) {
      let updatedList = null
      if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        updatedList = payload.updatedList
      }
      if (updatedList) {
        this.formData.promotion_apply_ticket_list = updatedList
      } else {
        this.formData.promotion_apply_ticket_list.unshift({
          ticket: null,
          customer_type: null,
          discount_value: null
        })
      }
    },
    removePromotionApplyTicketRow(payload) {
      let updatedList = null
      if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        updatedList = payload.updatedList
      }
      if (updatedList) {
        this.formData.promotion_apply_ticket_list = updatedList
      } else if (typeof payload === 'number' && this.formData.promotion_apply_ticket_list.length > 1) {
        this.formData.promotion_apply_ticket_list.splice(payload, 1)
      }
    },
    handleUpdateApplyTicketField({ updatedList }) {
      this.formData.promotion_apply_ticket_list = updatedList
    },

    onChangePromotionType(selected) {
      // Reset ticket condition trước khi gọi getCondition
      this.ticketConditionOptions = []
      this.ticketCondition = null

      if (this.formData.type != null && this.formData.department_type != null) {
        this.getCondition(selected, this.formData.department_type)
      }

      // reset dependency
      this.formData.condition_id = null
      this.formData.apply_id = null
      this.condition = null
      this.apply = null
      // Reset tất cả các trường về giá trị mặc định khi chuyển loại khuyến mãi
      // Nhưng giữ lại promotion_ticket_list nếu đang edit và vẫn là bộ phận Vé
      const preserveTicketList = this.promotionId &&
        this.formData.department_type === DEPARTMENT_VALUE.TICKET &&
        (selected === this.CODE_PROMOTION || selected === this.CODE_VOUCHER) &&
        this.formData.promotion_ticket_list &&
        this.formData.promotion_ticket_list.length > 0
      const savedTicketList = preserveTicketList ? this.formData.promotion_ticket_list : null
      this.formData = { ...this.formData, ...this.defaultValueIfChange }
      if (preserveTicketList && savedTicketList) {
        this.formData.promotion_ticket_list = savedTicketList
      }
    },
    onChangeDepartment(selected) {
      // Reset ticket condition trước khi gọi getCondition
      this.ticketConditionOptions = []
      this.ticketCondition = null

      // Lưu promotion_ticket_list trước khi reset nếu đang edit và chuyển từ Vé sang Vé
      const preserveTicketList = this.promotionId &&
        this.formData.department_type === DEPARTMENT_VALUE.TICKET &&
        selected === DEPARTMENT_VALUE.TICKET &&
        (this.formData.type === this.CODE_PROMOTION || this.formData.type === this.CODE_VOUCHER) &&
        this.formData.promotion_ticket_list &&
        this.formData.promotion_ticket_list.length > 0
      const savedTicketList = preserveTicketList ? this.formData.promotion_ticket_list : null

      if (this.formData.type != null && this.formData.department_type != null) {
        this.getCondition(this.formData.type, selected)
      }

      // reset dependency
      this.formData.condition_id = null
      this.formData.apply_id = null
      this.condition = null
      this.apply = null
      // Reset tất cả các trường về giá trị mặc định khi chuyển bộ phận
      // Nhưng giữ lại promotion_ticket_list nếu vẫn là bộ phận Vé
      this.formData = { ...this.formData, ...this.defaultValueIfChange }
      if (preserveTicketList && savedTicketList) {
        this.formData.promotion_ticket_list = savedTicketList
      }
    },

    // handle api call
    async fnGetPromotionDetail() {
      let res
      try {
        // Lấy loại từ searchParams.applyType được truyền từ component cha
        const applyType =
          this.searchParams?.applyType != null
            ? this.searchParams?.applyType
            : this.formData.type
        console.log('applyType from searchParams:', applyType)

        // Nếu loại đang là voucher thì gọi getVoucherDetail, ngược lại getNewPromotionDetail
        if (applyType === this.CODE_VOUCHER) {
          res = await getVoucherDetail(this.formData?.id)
        } else {
          res = await getNewPromotionDetail(this.formData?.id)
        }
        this.formData = { ...res.data }
        // Lưu ticket_type và ticket_list trước khi có thể bị ghi đè
        // Với voucher: dùng voucher_ticket_type và voucher_ticket_list
        // Với promotion: dùng promotion_ticket_type và promotion_ticket_list
        const ticketType = applyType === this.CODE_VOUCHER
          ? res.data.voucher_ticket_type
          : res.data.promotion_ticket_type
        const ticketList = applyType === this.CODE_VOUCHER
          ? res.data.voucher_ticket_list
          : res.data.promotion_ticket_list

        this.formData.type =
          this.searchParams?.applyType != null
            ? this.searchParams?.applyType
            : 0

        if (this.formData.is_apply_room === 1) {
          this.formData.department_type = DEPARTMENT_VALUE.RECEPTIONIST
        } else {
          this.formData.department_type = DEPARTMENT_VALUE.TICKET
        }

        //
        await this.getCondition(
          this.formData?.type,
          this.formData?.department_type
        )

        if (applyType === this.CODE_VOUCHER) {
          if (this.formData.department_type === DEPARTMENT_VALUE.RECEPTIONIST) {
            this.condition = this.conditionOptions.find(
              condition => condition.code === PROMOTION_CONDITION_CODE.bookingUseVoucher
            )
            if (this.condition) {
              this.formData.condition_id = this.condition.id
              await this.getApply(this.condition.code)
            }
          }
        } else {
          await this.getApply(this.formData?.promotion_type)
          this.condition = this.conditionOptions.find(
            condition => condition.code === this.formData?.promotion_type
          )

          if (this.condition) {
            this.formData.condition_id = this.condition.id
          }
        }

        // Apply ticket_condition_id nếu có
        if (this.formData.department_type === DEPARTMENT_VALUE.TICKET && (this.formData.type === this.CODE_PROMOTION || this.formData.type === this.CODE_VOUCHER)) {
          // Tìm ticket condition từ ticket_type (code) - hỗ trợ cả voucher và promotion
          if (ticketType) {
            this.ticketCondition = this.ticketConditionOptions.find(
              condition => condition.code === ticketType
            )
            if (this.ticketCondition) {
              this.formData.ticket_condition_id = this.ticketCondition.id
            }
          }

          // Map ticket_list từ API, loại bỏ các trường không cần thiết - hỗ trợ cả voucher và promotion
          if (ticketList && Array.isArray(ticketList)) {
            this.formData.promotion_ticket_list = ticketList.map(item => ({
              ticket: item.ticket,
              discount: item.discount,
              ticket_type: item.ticket_type,
              ticket_num: item.ticket_num,
              ticket_discount: item.ticket_discount,
              ticket_discount_type: item.ticket_discount_type,
              ticket_discount_num: item.ticket_discount_num
            }))
          } else {
            this.formData.promotion_ticket_list = []
          }

          // Map promotion_apply_ticket_list / voucher_apply_ticket_list (PM_TICKET_00)
          const applyTicketList = applyType === this.CODE_VOUCHER
            ? res.data.voucher_apply_ticket_list
            : res.data.promotion_apply_ticket_list
          if (applyTicketList && Array.isArray(applyTicketList) && applyTicketList.length > 0) {
            this.formData.promotion_apply_ticket_list = applyTicketList.map(item => ({
              ticket: item.ticket,
              customer_type: item.customer_type,
              discount_value: item.discount_value
            }))
            if (applyTicketList[0].discount_type != null) {
              this.formData.discount_type = applyTicketList[0].discount_type
            }
          } else if (this.ticketCondition?.code === 'PM_TICKET_00') {
            this.resetPromotionApplyTicketList()
          } else {
            this.formData.promotion_apply_ticket_list = []
          }
        }

        // Map các trường array, chuyển null thành mảng rỗng
        if (this.formData.ticket_type_list == null) {
          this.formData.ticket_type_list = []
        }
        if (this.formData.attached_room_list == null) {
          this.formData.attached_room_list = []
        }
        if (this.formData.room_type_list == null) {
          this.formData.room_type_list = []
        }
        if (this.formData.ticket_office_id_list == null) {
          this.formData.ticket_office_id_list = null
        }

        // Apply source_ids từ source_id_list trong response
        if (res.data.source_id_list && Array.isArray(res.data.source_id_list)) {
          this.formData.source_ids = res.data.source_id_list
        }

        // BE return ticket_point_id so FE need to parse tick_point_id to ticket_point
        this.formData.ticket_point = res.data.ticket_point || res.data.ticket_point_id

        // Update display value cho discount_value
        if (this.formData.discount_type != null) {
          this.updateDisplayDiscountValue(this.formData.discount_value)
        }
        if (applyType === this.CODE_VOUCHER) {
          this.updateDisplayMinOrderValue(this.formData.min_order_value)
          this.updateDisplayMaxDiscountValue(this.formData.max_discount_value)
        }
      } catch (error) {
        this.dialogformDataVisible = false
        console.error(error)
        const message = error.response?.data?.message || 'default'
        notifyError(message)
      } finally {
        //
      }
    },
    getFormattedDateTime() {
      const now = new Date()

      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')

      return `${year}-${month}-${day}_${hours}-${minutes}`
    },
    buildVoucherPayload(isUpdate = false) {
      const payload = {
        code: this.formData.code,
        name: this.formData.name,
        note: this.formData.note,
        description: this.formData.description || '',
        start_date: this.formData.start_date,
        end_date: this.formData.end_date,
        is_apply_room: 0,
        is_apply_ticket: 0,
        room_type_list: this.formData.room_type_list || [],
        num_night_apply: this.formData.num_night_apply,
        id: this.formData.id,
        discount_type: this.formData.discount_type,
        discount_value: this.formData.discount_value,
        min_order_value: this.formData.min_order_value,
        max_discount_value: this.formData.max_discount_value,
        stackable: this.formData.stackable || false,
        status: this.formData.status,
        ticket_point_id: this.formData.ticket_point || this.formData.ticket_point_id,
        ticket_office_id_list: this.formData.ticket_office_id_list || [],
        create_user_id: 0,
        department_tp: this.formData.department_type,
        ticket_type_list: this.formData.ticket_type_list || [],
        attached_room_list: this.formData.attached_room_list || [],
        prefix: this.formData.prefix,
        voucher_ticket_type: this.ticketCondition?.code || this.formData.voucher_ticket_type,
        voucher_ticket_list: this.formatPromotionTicketList(this.formData.promotion_ticket_list),
        voucher_apply_ticket_list: this.formatPromotionApplyTicketList(this.formData.promotion_apply_ticket_list)
      }

      if (!isUpdate) {
        payload.quantity = this.formData.number_sub_voucher
      }

      if (this.formData.department_type === DEPARTMENT_VALUE.RECEPTIONIST) {
        payload.is_apply_room = 1
      } else if (this.formData.department_type === DEPARTMENT_VALUE.TICKET) {
        payload.is_apply_ticket = 1
      }

      return payload
    },

    buildPromotionPayload() {
      const payload = {
        code: this.formData.code,
        name: this.formData.name,
        description: this.formData.description || '',
        status: this.formData.status,
        note: this.formData.note,
        start_date: this.formData.start_date,
        end_date: this.formData.end_date,
        department_tp: this.formData.department_type,
        promotion_type: this.condition?.code || this.formData.promotion_type,
        discount_type: this.formData.discount_type,
        discount_value: this.formData.discount_value,
        min_visit_count: this.formData.min_visit_count,
        max_visit_count: this.formData.max_visit_count,
        source_id_list: this.formData.source_ids || [],
        usage_limit: this.formData.usage_limit,
        usage_limit_per_customer: this.formData.usage_limit_per_customer,
        min_order_value: this.formData.min_order_value,
        max_discount_value: this.formData.max_discount_value,
        ticket_point: this.formData.ticket_point || this.formData.ticket_point_id,
        ticket_office_id_list: this.formData.ticket_office_id_list || [],
        is_apply_room: 0,
        is_apply_ticket: 0,
        num_night_apply: this.formData.num_night_apply,
        id: this.formData.id,
        create_user_id: 0,
        modify_user_id: 0,
        usage_count: this.formData.usage_count ?? 0,
        ticket_type_list: this.formData.ticket_type_list || [],
        room_type_list: this.formData.room_type_list || [],
        attached_room_list: this.formData.attached_room_list || [],
        promotion_ticket_type: this.ticketCondition?.code || this.formData.promotion_ticket_type,
        promotion_ticket_list: this.formatPromotionTicketList(this.formData.promotion_ticket_list),
        promotion_apply_ticket_list: this.formatPromotionApplyTicketList(this.formData.promotion_apply_ticket_list)
      }

      if (this.formData.department_type === DEPARTMENT_VALUE.RECEPTIONIST) {
        payload.is_apply_room = 1
      } else if (this.formData.department_type === DEPARTMENT_VALUE.TICKET) {
        payload.is_apply_ticket = 1
      }

      return payload
    },

    async fnCreatePromotion() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      if (
        this.formData.department_type === DEPARTMENT_VALUE.TICKET &&
        (this.formData.ticket_point_id == null && this.formData.ticket_point == null) &&
        this.formData.ticket_office_id_list == null
      ) {
        this.$message({
          message: 'Vui lòng chọn điểm áp dụng hoặc quầy áp dụng',
          type: 'error'
        })
        return
      }

      if (
        (this.formData.type === this.CODE_PROMOTION || this.formData.type === this.CODE_VOUCHER) &&
        this.ticketCondition?.code === 'PM_TICKET_00'
      ) {
        const applyList = this.formData.promotion_apply_ticket_list || []
        if (applyList.length > 1 && applyList.some(item => item.ticket == null)) {
          this.$message({
            message: 'Khi thêm từ 2 hàng trở lên, vui lòng chọn vé cho mỗi hàng',
            type: 'error'
          })
          return
        }
        if (this.hasDuplicateApplyTickets(applyList)) {
          this.$message({
            message: 'Danh sách vé áp dụng có hàng trùng tên vé mua và loại vé mua. Vui lòng kiểm tra lại.',
            type: 'error'
          })
          return
        }
      }

      if (this.ticketCondition?.code === 'PM_TICKET_01') {
        const ticketList = this.formData.promotion_ticket_list || []
        if (this.hasDuplicatePromotionTickets(ticketList)) {
          this.$message({
            message: 'Danh sách vé khuyến mãi có hàng trùng tên vé mua và loại vé mua. Vui lòng kiểm tra lại.',
            type: 'error'
          })
          return
        }
      }

      let res
      try {
        if (this.formData.type === this.CODE_VOUCHER) {
          res = await createVoucher(this.buildVoucherPayload(false))
        } else {
          res = await createNewPromotion(this.buildPromotionPayload())
        }
        const mimeType = res.type

        if (mimeType === 'application/json') {
          // It's a JSON object
          res.text().then(text => {
            const data = JSON.parse(text)
            console.log('Received JSON object:', data)
            notifySuccess(data.message)
          })
        } else {
          notifySuccess('createVoucherSuccessfully')
          // It's likely a file
          console.log('Received a file:', mimeType)
          console.log('Response:', res)
          const fileName = `voucher_${this.getFormattedDateTime()}.xlsx`

          downloadFile(res, fileName)
        }

        // notifySuccess('Thêm khuyến mại thành công')
        // if (res instanceof Blob) {
        //   downloadFile(res, 'Voucher.xlsx')
        // }
        this.$emit('refresh')
        this.onClose()
        this.dialogformDataVisible = false
      } catch (error) {
        console.error(error)
        let message = ''
        if (error.response?.type === 'application/json') {
          message = error.response?.data?.message || 'default'
        } else {
          await error.response?.data?.text().then(text => {
            const data = JSON.parse(text)
            message = data?.message || 'default'
          })
        }
        notifyError(message)
      } finally {
        //
      }
    },

    async fnUpdatePromotion() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      if (
        this.formData.department_type === DEPARTMENT_VALUE.TICKET &&
        (this.formData.ticket_point_id == null && this.formData.ticket_point == null) &&
        this.formData.ticket_office_id_list == null
      ) {
        this.$message({
          message: 'Vui lòng chọn điểm áp dụng hoặc quầy áp dụng',
          type: 'error'
        })
        return
      }

      if (
        (this.formData.type === this.CODE_PROMOTION || this.formData.type === this.CODE_VOUCHER) &&
        this.ticketCondition?.code === 'PM_TICKET_00'
      ) {
        const applyList = this.formData.promotion_apply_ticket_list || []
        if (applyList.length > 1 && applyList.some(item => item.ticket == null)) {
          this.$message({
            message: 'Khi thêm từ 2 hàng trở lên, vui lòng chọn vé cho mỗi hàng',
            type: 'error'
          })
          return
        }
        if (this.hasDuplicateApplyTickets(applyList)) {
          this.$message({
            message: 'Danh sách vé áp dụng có hàng trùng tên vé mua và loại vé mua. Vui lòng kiểm tra lại.',
            type: 'error'
          })
          return
        }
      }

      if (this.ticketCondition?.code === 'PM_TICKET_01') {
        const ticketList = this.formData.promotion_ticket_list || []
        if (this.hasDuplicatePromotionTickets(ticketList)) {
          this.$message({
            message: 'Danh sách vé khuyến mãi có hàng trùng tên vé mua và loại vé mua. Vui lòng kiểm tra lại.',
            type: 'error'
          })
          return
        }
      }

      let res
      try {
        if (this.formData.type === this.CODE_VOUCHER) {
          res = await updateVoucher(this.buildVoucherPayload(true))
        } else {
          res = await updateNewPromotion(this.buildPromotionPayload())
        }
        notifySuccess(res.message)
        this.$emit('refresh')
        this.onClose()
        this.dialogformDataVisible = false
      } catch (error) {
        console.error(error)
        const message = error.response?.data?.message || 'default'
        notifyError(message)
      } finally {
        //
      }
    },

    async getTicketPointList() {
      const res = await getTicketPointListApi()
      this.ticketPointList = res.data
    },
    async getTicketOfficeList() {
      const res = await getTicketOfficeListApi()
      this.ticketOfficeList = res.data
    },
    async getSourceList() {
      const res = await getSourceListApi({
        isActive: 1
      })
      this.sourceOptions = res.data
    },
    async getSourceGroupList() {
      const res = await getSourceGroupApi({
        isActive: 1
      })
      this.sourceGroupOptions = res.data
    },
    async getTicketOptions() {
      const res = await getTicketListApi()
      this.ticketOptions = res.data
    },
    async getNoChildTicketOptions() {
      const res = await getNoChildTicketApi()
      this.noChildTicketOptions = res.data
    },
    async geTicketType() {
      const res = await getTicketTypeApi()
      this.ticketTypeOptions = res.data
    },
    async getRoomType() {
      const res = await getAllRoomLevelApi()
      this.roomTypeOptions = res.data
    },

    onChangeRoomType(selectedRoomTypes) {
      this.formData.room_type_list = selectedRoomTypes || []
    },
    onChangeAttachedRoom(selectedRoomTypes) {
      console.log('DEBUG: ', selectedRoomTypes)
      this.formData.attached_room_list = selectedRoomTypes || []
    }
  }
}
</script>

<style lang="scss" scoped>
.das-form-container > * + * {
  margin: 1rem 0;
}

// .el-dialog__body {
//   overflow: ;
// }

::v-deep {
  .el-dialog__body {
    overflow: auto;
  }
}

.promotion-ticket-table {
  width: 100%;
  margin-top: 1rem;
  max-height: 400px;
  overflow-y: auto;

  .table-header {
    margin-bottom: 0.5rem;
    h4 {
      margin: 0;
      font-weight: 600;
    }
  }

  .ticket-list-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #e0e0e0;

    thead {
      background-color: #e8f5e9;

      th {
        padding: 8px;
        text-align: left;
        border: 1px solid #e0e0e0;
        font-weight: 600;
        font-size: 14px;
        color: #000;

        &:nth-child(1) {
          width: 22%;
        }
        &:nth-child(2) {
          width: 14%;
        }
        &:nth-child(3) {
          width: 8%;
        }
        &:nth-child(4) {
          width: 22%;
        }
        &:nth-child(5) {
          width: 14%;
        }
        &:nth-child(6) {
          width: 8%;
        }
        &:nth-child(7) {
          width: 8%;
        }
        &:nth-child(8) {
          width: 4%;
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #e0e0e0;

        &:hover {
          background-color: #fafafa;
        }
      }

      td {
        padding: 8px;
        border: 1px solid #e0e0e0;

        input,
        .el-select {
          width: 100%;
        }

        &:nth-child(1),
        &:nth-child(4) {
          min-width: 180px;
        }

        &:nth-child(3),
        &:nth-child(6),
        &:nth-child(7) {
          width: 80px;
          min-width: 80px;
          max-width: 80px;
        }

        &:nth-child(8) {
          width: 50px;
          min-width: 50px;
          max-width: 50px;
        }
      }
    }
  }

  .btn-icon {
    padding: 4px 8px;
    margin: 0 2px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;

    &:hover:not(:disabled) {
      background-color: #ecf5ff;
      border-color: #b3d8ff;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &.btn-add {
      color: #67c23a;
      border-color: #67c23a;

      &:hover:not(:disabled) {
        background-color: #f0f9ff;
        border-color: #67c23a;
      }
    }

    &.btn-remove {
      color: #f56c6c;
      border-color: #f56c6c;

      &:hover:not(:disabled) {
        background-color: #fef0f0;
        border-color: #f56c6c;
      }
    }
  }
}
</style>
